export default {"src":"/canvas/_next/static/media/icon-yahoo-t5.06ffb091.svg","height":1792,"width":1792,"blurWidth":0,"blurHeight":0};